import { useQuery } from '@tanstack/react-query';

import { makeAPIRequestReactQuery } from '@/react-query/api';

const TEN_MINUTES = 10 * 60 * 1000;

export const useHasWriteback = (
  practiceId: string | undefined,
  organizationId: string | undefined,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['videa-notes-writeback', organizationId, practiceId],
    queryFn: async () => {
      const data = await makeAPIRequestReactQuery<{
        hasWritebackSupport: boolean;
      }>('/videa-notes/writeback', {}, 'get', {
        headers: {
          'Access-Control-Allow-Origin': '*',
          practice: practiceId,
          org: organizationId,
        },
      });
      return data.hasWritebackSupport;
    },
    enabled: !!practiceId && !!organizationId && enabled,
    staleTime: TEN_MINUTES,
    cacheTime: TEN_MINUTES,
  });
};
